// The spine-authority vocabulary — the SINGLE machine-readable action table the FE gates against, copied
// verbatim from the backend (spine-vocabulary.v1.json; the TS SPINE_ACTIONS const is the SSOT, this is a
// checked-in projection). Never hardcode a second action list. verify-spine-vocabulary.mjs FAILS on drift.

import vocab from './spine-vocabulary.v1.json';

/** The 18 governed-write actions (SpineAction). Controls enable iff the action is in allowed_actions. */
export const SPINE_ACTIONS = vocab.actions as readonly string[];

export type SpineAction = (typeof vocab.actions)[number];
export type SpineDenyReason = (typeof vocab.deny_reasons)[number];

/** True if `a` is a known action — a control mapped to an unknown action is a build error, not a 403. */
export function isKnownAction(a: string): a is SpineAction {
  return (SPINE_ACTIONS as readonly string[]).includes(a);
}

/** The `identity.spine_authority` envelope from GET /session. */
export interface SpineAuthority {
  allowed_actions: SpineAction[];
  disabled_reasons: Partial<Record<SpineAction, SpineDenyReason>>;
  enforced: boolean;
}
